export const repairContent = [
  {
    heroTitle: "Need An Emergency Boiler Repair?",
    heroImg: "",
  },
  {
    introTitle: "We Repair Boilers Throughout Leeds & West Yorkshire",
    introText:
      "We specialise in boiler repairs for homeowners and business owners. Getting left with no heating or hot water is always less than ideal. However, our Gas Safe engineers are never far away.",
  },
  {
    contLeftTitle: "Fast & Responsive Boiler Repairs",
    contLeftText: `Our Gas Safe boiler engineers can help with all aspects of boiler repairs and maintenance, and we'll always try and fix the problem first.`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643103525/AquaHeat/new%20images/Screenshot_2022-01-25_at_09.31.02_fqr9v0.webp`,
  },
  {
    contRightTitle: "We Repair All Types of Boilers",
    contRightText: `We can offer boiler repairs on combi, conventional, BBU and system boilers. If you're having issues with your boiler, contact the team at Aquaheat`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_580/v1643100767/AquaHeat/new%20images/Boiler-Repair-1_bn44ze.webp`,
  },
  {
    callToActionTitle: "For 24HR Response Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
